import React from 'react';

const FeedModule = ({ data, config }) => {
  const maxItems = config.maxItems || 5;
  const feedData = data.slice(0, maxItems);

  return (
    <div className="space-y-3">
      {feedData.map((item, index) => (
        <div key={index} className="flex items-start space-x-3 p-3 hover:theme-bg-secondary rounded-lg">
          <div className="flex-shrink-0">
            <div className="w-10 h-10 bg-primary-100 rounded-full flex items-center justify-center">
              <span className="text-primary-600 font-semibold">
                {item.author ? item.author[0].toUpperCase() : 'U'}
              </span>
            </div>
          </div>
          <div className="flex-1">
            <div className="flex items-center justify-between">
              <h4 className="text-sm font-medium theme-primary">{item.title}</h4>
              <span className="text-xs text-gray-500">{item.timestamp || '2h ago'}</span>
            </div>
            <p className="text-sm theme-secondary mt-1">{item.content}</p>
            {item.actions && (
              <div className="flex space-x-2 mt-2">
                {item.actions.map((action, actionIndex) => (
                  <button
                    key={actionIndex}
                    onClick={action.onClick}
                    className="text-xs text-primary-600 hover:text-primary-800"
                  >
                    {action.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FeedModule;
